// "Ship to a different address": opens/closes the shipping section. The template renders it collapsed
// (woocommerce/checkout/form-billing-shipping.php, inline height: 0) unless the box starts checked.
// Plain jQuery, no GSAP: the old version waited for a $dependencyManager callback that never fired.
jQuery(() => {
  const $section = jQuery('#checkout-section-shipping');
  if (!$section.length) return;

  jQuery(document.body).on('change', '#ship-to-different-address-checkbox', function () {
    $section.stop(true);

    if (this.checked) {
      $section.animate({ height: $section.get(0).scrollHeight }, 400, () => {
        // Auto height afterwards, so validation messages or a state field can still grow the section.
        $section.css('height', 'auto');
      });
      jQuery('html, body').animate({ scrollTop: $section.offset().top - 120 }, 500);
    } else {
      $section.css('height', $section.outerHeight()).animate({ height: 0 }, 400);
    }

    // Shipping destination changed: recalculate shipping and totals (as WooCommerce core does).
    jQuery(document.body).trigger('update_checkout');
  });
});
